// @flow weak

import { bindActionCreators } from 'redux';
import { connect }            from 'react-redux';
import * as actions           from '../../redux/modules/actions';
import StatsCard              from './statsCard';

const mapStateToProps = (state) => {
  return {
    currentView:  state.views.currentView
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions : bindActionCreators(
      {
        enterStatsCard: actions.enterStatsCard,
        leaveStatsCard: actions.leaveStatsCard
      },
      dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StatsCard);



// WEBPACK FOOTER //
// ./src/app/views/statsCard/index.js